import React, { useState, useEffect } from "react";
import "./footer.scss";
import logow from "../../assets/logo/new-logo-white.png";
import { IoCallOutline, IoLocationOutline } from "react-icons/io5";
import { MdOutlineEmail } from "react-icons/md";
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { getCountryPhoneDetails } from "../../utils/countryUtils";

const Footer = () => {
  const [phoneDetails, setPhoneDetails] = useState({
    number: '+1 408 693 6337', // Default number
    flag: ''
  });

  useEffect(() => {
    const fetchPhoneDetails = async () => {
      const details = await getCountryPhoneDetails();
      setPhoneDetails(details);
    };

    fetchPhoneDetails();
  }, []);

  return (
    <>
      <div className="footer-parent parent">
        <div className="footer-container container">
          <div className="footer-top">
            <div className="footer-left-box">
              <div className="footer-logo">
                <img src={logow} alt="" />
              </div>
              <p className="company-about">
                AxonCare, a service brand by Axonic, is a global healthcare
                network that connects doctors and patients worldwide through
                cutting-edge technology solutions.
              </p>
            </div>

            <div className="footer-right-box">
              <div className="footer-icon-box">
                <a
                  target="__blank"
                  href="https://www.facebook.com/axoncarebyaxonichealth/"
                  className="facebook footer-link"
                >
                  <FaFacebookF />
                </a>
                <a
                  target="__blank"
                  href="https://www.linkedin.com/company/axoncare-by-axonichealth/"
                  className="Linkedin footer-link"
                >
                  <FaLinkedinIn />
                </a>
                <a
                  target="__blank"
                  href="https://www.instagram.com/axoncare_by_axonichealth"
                  className="instagram footer-link"
                >
                  <FaInstagram />
                </a>
              </div>

              <div className="footer-adresses">
                <a href={`tel:${phoneDetails.number}`} className="footer-mail-box">
                  <span className="footer-icon">
                    <IoCallOutline />
                  </span>
                  <p> {phoneDetails.number} {phoneDetails.flag}</p>
                </a>
                <a
                  href="mailto:support@axoncare.io"
                  className="footer-mail-box"
                >
                  <span className="footer-icon">
                    <MdOutlineEmail />
                  </span>
                  <p>support@axoncare.io</p>
                </a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
                          <p>Copyright © 2024 Axonic All rights reserved</p>
              <p>
                <Link to="/contact" style={{ color: "var(--accent-yellow)" }}>
                  Contact Us
                </Link>
              </p>
          </div>
        </div>
      </div>

    </>
  );
};

export default Footer;
